import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Popup } from 'react-leaflet';
import Moment from 'react-moment';
import ListingImages from 'components/common/listing/listing-item/ListingImages';
import { MAKE_AN_OFFER } from 'helpers/constant';

const MapViewListingPopup = ({ listing }) => {
  return (
    <Popup closeButton={false}>
      <div className="overflow-hidden">
        <ListingImages images={listing.images?.items} layout="grid" />
        <div className="p-3">
          <h5 className="fs-9">
            <Link className="text-1100" to={`/listings/${listing.id}`}>
              {listing.title}
            </Link>
          </h5>
          <p className="fs-10 mb-3">
            <Link to="#!" className="text-500"></Link>
          </p>
          <h5 className="fs-md-7 text-warning mb-0 d-flex align-items-center mb-3">
            {listing.pricingOption !== MAKE_AN_OFFER
              ? `$${listing.price}`
              : 'Make an offer'}
          </h5>
          <p className="fs-10 mb-1">
            <Moment fromNow utc local>
              {listing.createdAt}
            </Moment>{' '}
            by{' '}
            {`${listing.createdByUser.firstName} ${listing.createdByUser.lastName}`}
          </p>
          <p className="fs-10 mb-1"></p>
        </div>
      </div>
    </Popup>
  );
};

MapViewListingPopup.propTypes = {
  listing: PropTypes.object.isRequired
};

export default MapViewListingPopup;
